import React, { useEffect, useRef, useState } from "react";
import classes from "./FactsNFiguresMobile.module.css";

import Space from "../../UI/Space/Space";
import Figure from "./Figure/Figure";
import Button from "../../UI/Button/Button";
import Modal from "../../UI/Modal/Modal";
import CareersForm from "./Forms/Careers/CareersForm"
import StayTuned from "./Forms/StayTuned/StayTuned";


import ContactUs from "./Forms/ContactUs/ContactUs"
import PartnershipPrograms from "../../FactsNFigures/PartnershipPrograms";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../../store/Slices/ScrollSlice";

import Stethoscope from "../../../images/stethoscope.png";
import Physiotherapy from "../../../images/physiotherapy.png";
import ABC from "../../../images/ABC.png";
import Evaluation from "../../../images/evaluation.png";
import Gears from "../../../images/gears.png";
import Hearing from "../../../images/hearing.png";
import Lab from "../../../images/labBottle.png";
import psychoTherapy from "../../../images/psychotherapy.png";
import speechTherapy from "../../../images/speechTherapy.png";
import Xray from "../../../images/xray.png";
import Prosthetic from "../../../images/prosthetic.png";
import MedicalCare from "../../../images/medicalcare.png";

//This component shows the Facts and figures about LWAH and is placed under the Map section
const FactsNFiguresMobile = () => {
  const dispatch = useDispatch();
  const container = useRef(null);

  const [isCareersOpen, setIsCareersOpen] = useState(false);
  const [isStayTunedOpen, setIsStayTunedOpen] = useState(false);
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);

  const openCareers = (event) => {
    setIsCareersOpen(true);
  };
  const openStayTuned = (event) => {
    setIsStayTunedOpen(true);
  };
  const openContactUs = (event) => {
    setIsContactUsOpen(true);
  };
  const cancel = () => {
    setIsCareersOpen(false);
    setIsStayTunedOpen(false);
    setIsContactUsOpen(false)
  };



  return (
    <div className={classes.container} ref={container}>
      {isCareersOpen && (
        <Modal cancel={cancel} title={"Careers"} circle={2000} mobile={true}>
          <CareersForm />
        </Modal>
      )}
      {isStayTunedOpen && (
        <Modal cancel={cancel} title={"Stay Tuned"} circle={2500} mobile={true}>
          <StayTuned />
        </Modal>
      )}
      {isContactUsOpen && (
        <Modal cancel={cancel} title={"Contact Us"} circle={2500} mobile={true}>
          <ContactUs/>
        </Modal>
      )}
      <Space height={"100px"} />
      <div className={classes.bigNumber}>
       33,393
      </div>
      <div className={classes.bigTitle}>BENEFICIARIES</div>
      <Space height={"25px"} />
      <div className={classes.item}>
        <h4>
          <span className={classes.yellow}>LWAH</span> provides a wide range of
          social and medical services in its different centers, including{" "}
          <span className={classes.yellow}>LWAH</span>'s rehabilitation center,
          Beirut and Baalbeck Centers. There was 13% increase in provided
          services between 2018 and 2017
        </h4>
      </div>
      <Space height={100} />
      <div className={classes.row}>
        <Figure
          icon={Stethoscope}
          leftNumber={8090}
          rightNumber={15248}
          title="Registered cases at LWAH Clinics for consultations, follow-up and vaccination"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={Physiotherapy}
          leftNumber={897}
          rightNumber={677}
          title="Physiotherapy Patients"
          static={true}
        />
      </div>
      {/* <Space height={100} /> */}
      <div className={classes.row}>
        <Figure
          icon={Evaluation}
          leftNumber={39}
          rightNumber={268}
          title="Underwent Evaluation Tests including TOVA, IQ and CAT"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={Lab}
          leftNumber={887}
          rightNumber={3626}
          title="Laboratory Visits"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={speechTherapy}
          leftNumber={327}
          rightNumber={440}
          title="Speech Therapy Patients"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={Gears}
          leftNumber={345}
          rightNumber={331}
          title="Psychomotor Therapy Patients"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={Xray}
          leftNumber={479}
          rightNumber={2232}
          title="Imaging Services including X-Ray, Ultrasound and Mammography"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={Hearing}
          leftNumber={262}
          rightNumber={308}
          title="Hearing Aids"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={ABC}
          leftNumber={463}
          rightNumber={254}
          title="Occupational Therapy Patients"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={psychoTherapy}
          leftNumber={228}
          rightNumber={334}
          title="Psychotherapy Patients"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={Prosthetic}
          leftNumber={365}
          rightNumber={110}
          title="Received Prosthetic and Orthotic Devices"
          static={true}
        />
      </div>
      <div className={classes.row}>
        <Figure
          icon={MedicalCare}
          leftNumber={13654}
          rightNumber={230}
          title="Beneficiary of Cases Of Technical And Medical AIDS"
          static={true}
        />
      </div>
      <Space height={100} />
      <PartnershipPrograms />
      <Space height={100} />
      <div className={classes.cards}>
        <Button className={classes.card} onClick={openContactUs}>
          <h3>CONTACT US</h3>
        </Button>
        <Button className={classes.card} onClick={openCareers}>
          <h3>CAREERS</h3>
        </Button>
        <Button className={classes.card} onClick={openStayTuned}>
          <h3>STAY TUNED</h3>
        </Button>
      </div>
      <Space height={100} />
    </div>
  );
};
export default FactsNFiguresMobile;
